export default {
  topLevel: ['storage', 'exchange', 'publiclink'],
  storage: ['favorite', 'created', 'available', 'basket'],
  exchange: [],
  received: [],
  sent: [],
  favorite: [],
  created: [],
  available: [],
  basket: [],
};
